import React from "react";
import PropTypes from "prop-types";
import PulseLoader from "react-spinners/PulseLoader";
import { withTranslation } from "react-i18next";
import { Dropdown, TextInput } from "hesus-ui-kit";
import { updateUnitTranslation } from "@utils/utils";

import {
  GridRow,
  OptionLabel,
  SectionContainer,
  APIErrorMEssage,
  LoadingContainer,
} from "../AddEditSolution.styled";

const TransportOnly = (props) => {
  const {
    data,
    currencies,
    transportTypes,
    transportTypesAPIError,
    isTransportTypesLoading,
    onPriceBySelect,
    onTransportTypeSelect,
    onTransportUnitSelect,
    onTransportPriceChange,
    onTransportCurrencySelect,
    t,
    unitList,
  } = props;

  return (
    <SectionContainer>
      <OptionLabel>{t("TRANSPORT_ONLY")}</OptionLabel>
      <GridRow>
        <Dropdown
          label={t("MANUAL_MATCHING_CREATION_POP_UP_PRICE_BY")}
          name="solution-dropdown-price-by"
          value={
            data.transportPriceType?.value
              ? parseInt(data.transportPriceType.value, 10)
              : ""
          }
          defaultOption={t("NONE_SELECTED")}
          containerStyles={{ marginBottom: "1.32rem" }}
          inputStyles={{ border: "1px solid #474747" }}
          options={[
            {
              label: t("ADMIN_OPTMIZED"),
              value: 4,
            },
            {
              label: t("SUPPLIER_OPTIMIZED"),
              value: 3,
            },
          ]}
          required
          error={data.transportPriceType.error}
          onChange={onPriceBySelect}
        />
        {transportTypesAPIError !== "" && (
          <APIErrorMEssage>{transportTypesAPIError}</APIErrorMEssage>
        )}
        {isTransportTypesLoading && (
          <LoadingContainer>
            <PulseLoader color="#004c7f" />
          </LoadingContainer>
        )}
        {!isTransportTypesLoading && transportTypesAPIError === "" && (
          <Dropdown
            label={t("TRANSPORT_TYPE")}
            name="solution-dropdown-transport-type"
            value={
              data.transportType?.value
                ? parseInt(data.transportType?.value, 10)
                : ""
            }
            defaultOption={t("NONE_SELECTED")}
            containerStyles={{ marginBottom: "1.32rem" }}
            inputStyles={{ border: "1px solid #474747" }}
            options={transportTypes}
            required
            error={data.transportType.error}
            onChange={onTransportTypeSelect}
          />
        )}
      </GridRow>
      <GridRow>
        <TextInput
          type="text"
          label={t("TRANSPORT_PRICE")}
          name="transport-price"
          id="transport-price"
          value={data.transportPrice}
          onChange={onTransportPriceChange}
          isFloat
          containerStyles={{ marginTop: "1.32rem" }}
          inputStyles={{ padding: "0.43rem 0.32rem 0.43rem 0.625rem" }}
        />
        <Dropdown
          label={t("MATCHING_TREATMENT_PRICE_CURRENCY")}
          name="transport-only-currency"
          value={String(data.transportCurrency.value)}
          defaultOption={t("SELECT_CURRENCY")}
          containerStyles={{ marginBottom: "1.32rem" }}
          inputStyles={{ border: "1px solid #474747" }}
          options={currencies}
          required
          error={data.transportCurrency.error}
          onChange={onTransportCurrencySelect}
        />
        <Dropdown
          label={t("UNIT")}
          name="transport-only-unit"
          value={String(data.transportUnit)}
          defaultOption={t("NONE_SELECTED")}
          containerStyles={{ marginBottom: "1.32rem" }}
          inputStyles={{ border: "1px solid #474747" }}
          options={updateUnitTranslation(unitList, t)}
          onChange={onTransportUnitSelect}
        />
      </GridRow>
    </SectionContainer>
  );
};

TransportOnly.propTypes = {
  data: PropTypes.shape({
    transportPriceType: PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      error: PropTypes.string,
      required: PropTypes.bool,
    }),
    transportType: PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      error: PropTypes.string,
      required: PropTypes.bool,
    }),
    transportPrice: PropTypes.string,
    transportUnit: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    transportCurrency: PropTypes.shape({
      value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      error: PropTypes.string,
      required: PropTypes.bool,
    }),
    transportPriceInternalComment: PropTypes.string,
  }).isRequired,
  currencies: PropTypes.arrayOf(PropTypes.object).isRequired,
  transportTypes: PropTypes.arrayOf(PropTypes.object).isRequired,
  transportTypesAPIError: PropTypes.string.isRequired,
  isTransportTypesLoading: PropTypes.bool.isRequired,
  onPriceBySelect: PropTypes.func.isRequired,
  onTransportTypeSelect: PropTypes.func.isRequired,
  onTransportUnitSelect: PropTypes.func.isRequired,
  onTransportPriceChange: PropTypes.func.isRequired,
  onTransportCurrencySelect: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(TransportOnly);
